"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SENTINEL_PID = exports.EXTENDED_PID = void 0;
exports.EXTENDED_PID = 0x3f01;
exports.SENTINEL_PID = 0x3f02;
//# sourceMappingURL=reservedPIDs.js.map